import angular from 'angular';
import indexShardsTabContent from './index-shards-tab-content.component';

export default angular.module('eshq.indexShardsTabContent', [])
  .component('eshqIndexShardsTabContent', indexShardsTabContent)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/index-shards-tab-content/index-shards-tab-content.js